import isPropValid from '@emotion/is-prop-valid';

const componentBaseConfig = {
  shouldForwardProp: isPropValid
};

export { componentBaseConfig };
//# sourceMappingURL=componentBaseConfig.js.map
